import type { ComponentType } from 'react';
import Box, { type BoxProps } from '@mui/material/Box';
import Chip, { type ChipProps } from '@mui/material/Chip';
import { Link, type LinkProps } from "infrastructure/router";
import Loader from 'ui/molecules/Loader';
import { useApplicationDetailContext } from '../ApplicationDetailProvider';

export type StepLabelProps =
    & LinkProps
    & BoxProps
    & Pick<ChipProps, 'color' | 'label'>
    & {
        readonly Icon: ComponentType;
    };

const StepLabel = ({
    children,
    Icon,
    color,
    label,
    ...restProps
}: StepLabelProps) => {
    const { isLoading } = useApplicationDetailContext();

    return (
        <Box
            {...restProps}
            component={Link}
            sx={{
                display: 'grid',
                gridTemplateColumns: 'auto 1fr auto',
                alignItems: 'center',
                gap: 1,
                textDecoration: 'none',
                whiteSpace: 'nowrap',
                color: 'inherit',
                bgcolor: 'inherit',
                borderRadius: 'inherit',
                py: 1,
                px: 2,
                ...restProps.sx
            }}
        >
            <Icon />
            <Box>
                {children}
            </Box>
            <Loader
                isLoading={isLoading}
                slotProps={{
                    progress: {
                        size: 16,
                        color: 'warning'
                    }
                }}
            >
                <Chip
                    size='small'
                    variant='outlined'
                    color={color}
                    label={label}
                />
            </Loader>
        </Box>
    );
};

export default StepLabel;
